
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
  import Dialog from '@/components/dialog.vue';
  import uploadImg from '@/components/upload-img.vue';
  import {
    ownBrandlist,
    ownBranddelete,
    ownBrandsave,
    ownBranddetail,
    ownBrandCarousellist,
    ownBrandCarouselsave
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-message': Message,
      'slz-dialog': Dialog,
      uploadImg
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private rowmsg:any = {}
    private delShow = false
    private editShow = false
    private slideShow = false
    private slideListFull:any = []
    private slideList:any = []


    private mounted () {
      this.gettablelist()

    }

    private activated () {
      this.gettablelist()
    }



    private async saveSlide(){
      try{
        let res = await ownBrandCarouselsave({
          OwnBrandCarouselList:this.slideList.map((v,i)=>{
            return {
              ImgUrl:v,
              Sort:i+1,
              Id:0
            }
          })
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.slideShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private uploadSuc(list){
      this.slideList = list
    }
    private async editSlide(){
      this.slideShow = true
      try{
        let res = await ownBrandCarousellist({})
        if(res.IsSuccess){
          this.slideListFull = res.Result
          this.slideList = res.Result.map(v=>v.ImgUrl)
        }
      }finally{
        //
      }
    }
    private toManage(row){
      this.$router.push({
        path:'/product/selfOwnedBrandShopManage',
        query:{
          Id:row.Id,
          Name:encodeURIComponent(row.OwnBrandName)
        }
      })
    }
    private async saveEdit(){
      if(!this.rowmsg.OwnBrandName){
        this.$message.error('请输入品牌名称')
        return 
      }
      try{
        let res = await ownBrandsave(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.editShow = false
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private async toEdit(row){
      if(row.Id){
        try{
          let res = await ownBranddetail({
            Id:row.Id
          })
          if(res.IsSuccess){
            this.rowmsg = res.Result
          }
        }finally{
          //
        }
      }else{
        this.rowmsg = {
          Id:0,
          OwnBrandName:'',
        }
      }
      this.editShow = true
    }
    private async confirmDel(){
      try{
        let res = await ownBranddelete({Id:this.rowmsg.Id})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await ownBrandlist({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
